/**
 * Hide validation messages when input
 * fields are being edited by the user
 */
const init = () => {
	const fields = document.querySelectorAll('.required .form-control');

	fields.forEach(input => input.addEventListener('keyup', hideValidationMessage));
	fields.forEach(input => input.addEventListener('change', hideValidationMessage));
};

const hideValidationMessage = (event) => {
	if (!event.target.nextElementSibling) return;

	if (event.target.nextElementSibling.classList.contains('help-block')) {
		event.target.nextElementSibling.style.display = "none";
	}
};

init();
